export const B2B_NOTES_ALLOWED_HTML_TAGS = [
	"p",
	"h2",
	"h3",
	"ul",
	"ol",
	"li",
	"a",
	"strong",
	"em",
	"u",
] as const;

const ALLOWED_HTML_TAG_PATTERN = /<(p|h2|h3|ul|ol|li|a|strong|em|u)\b/i;

export function isLikelyHtml(value: string): boolean {
	const trimmed = value.trim();
	return trimmed.startsWith("<") && ALLOWED_HTML_TAG_PATTERN.test(trimmed);
}

export function isLegacyPlainTextNotes(notes?: string | null): boolean {
	if (!notes?.trim()) return false;
	return !isLikelyHtml(notes);
}

function getVisibleTextFromHtml(html: string): string {
	return html
		.replace(/<[^>]*>/g, "")
		.replace(/&nbsp;/gi, " ")
		.replace(/&amp;/g, "&")
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&quot;/g, '"')
		.replace(/&#39;/g, "'")
		.trim();
}

export function isB2bNotesEmpty(notes?: string | null): boolean {
	if (!notes?.trim()) return true;

	const trimmed = notes.trim();
	if (isLikelyHtml(trimmed)) {
		return getVisibleTextFromHtml(trimmed).length === 0;
	}

	return false;
}

export function wrapLegacyNotesAsHtml(notes: string): string {
	const trimmed = notes.trim();
	const escaped = trimmed
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");
	return `<p>${escaped}</p>`;
}

export function resolveB2bNotesHtml(notes?: string | null): string | null {
	if (isB2bNotesEmpty(notes)) return null;
	if (isLegacyPlainTextNotes(notes)) return wrapLegacyNotesAsHtml(notes!);
	return notes!.trim();
}
